// Sovereign design tokens — mirror of marketing/launch-site/index.html :root.
// Single source of truth for palette + phi scale used across the 3D scene and overlay.

export const PHI = 1.618

export const COLORS = {
  graphite900: '#15171A',
  graphite800: '#1C1F24',
  graphite700: '#262A30',
  graphite600: '#32373F',
  graphite400: '#6B7280',
  graphite300: '#9AA1AB',
  paper50: '#F7F6F3',
  paper100: '#ECEAE3',
  gold500: '#C9A227',
  gold300: '#E4C766',
  gold700: '#8A6E15',
  ember: '#FF5A36',
  ember600: '#E54322',
} as const

export const FONTS = {
  serif: "'Fraunces', Georgia, 'Times New Roman', serif",
  sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
} as const

export const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)'
